import { render, staticRenderFns } from "./UnitEdit.vue?vue&type=template&id=4d539b8d&scoped=true&"
import script from "./UnitEdit.vue?vue&type=script&lang=js&"
export * from "./UnitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d539b8d",
  null
  
)

export default component.exports